<script lang="ts">
export default {
  name: 'KkRadioGroup',
}
</script>

<script lang="ts" generic="T" setup>
import { computed } from 'vue'

export type RadioItem = {
  id: string | number
  value: string | number | boolean
  text: string
  disabled?: boolean
}

export interface Props {
  name: string
  items: RadioItem[]
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  modelValue: T
}

export interface Emits {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  (key: 'update:modelValue', value: T): void
}

const props = defineProps<Props>()
const emits = defineEmits<Emits>()

const valueModel = computed({
  get: () => props.modelValue,
  set: (value) => emits('update:modelValue', value)
})
</script>

<template>
  <div class="radio">
    <div v-for="item in props.items" :key="`kk_radio_btn_${item.id}`" class="radio__item">
      <input
        :id="String(item.id)"
        v-model="valueModel"
        :value="item.value"
        :name="name"
        :disabled="item.disabled"
        type="radio"
        class="radio__input"
      >
      <label :for="String(item.id)" class="radio__label">
        {{ item.text }}
      </label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../stylesheets/biz_spa/foundation/_var.scss";
.radio {
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  margin-top: 8px;
  &__item {
    padding: 0 12px 0 0;
  }
  &__input {
    display: none;
    &:checked + .radio__label {
      &::before {
        background-color: $color-accent-form;
      }
    }
    &:disabled {
      + .radio__label {
        color: #E3E3E3;
        cursor: not-allowed;

        &::after {
          display: none;
        }
      }
    }
  }
  &__label {
    display: inline-block;
    position: relative;
    padding-left: 24px;
    font-size: 14px;
    line-height: 16px;
    cursor: pointer;
    transition: .2s;
    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: $color-base-h;
      content: "";
      transition: .2s;
    }
    &::after {
      position: absolute;
      top: 5px;
      left: 4px;
      transform: rotate(-45deg);
      width: 8px;
      height: 4px;
      content: "";
      border-left: 2px solid #FFF;
      border-bottom: 2px solid #FFF;
    }
  }
}
</style>
